const EMPLOYER_TYPE_LABELS = {
  direct_employer: "Direktarbeitgeber",
  staffing_agency: "Staffing Agency",
  recruiter_intermediary: "Recruiter / Vermittler",
  consultant_third_party: "Consultant / Dritter",
  unknown_unverified: "Unklar / ungeprueft",
  rejected_misrepresentation: "Abgelehnt wegen Falschdarstellung",
};

const EMPLOYER_CLASSIFICATION_LABELS = {
  enterprise: "Institutioneller Arbeitgeber",
  public_institution: "Oeffentliche Einrichtung",
  hospital_or_care: "Klinik / Pflege / Care",
  medium_business: "Mittlerer Betrieb",
  small_business: "Kleiner Betrieb",
  micro_business: "Mikrobetrieb",
  staffing_agency: "Staffing Agency",
  recruiter_intermediary: "Recruiter / Vermittler",
  unknown: "Unklar",
};

const TRUST_TIER_META = {
  tier_1_verified_institutional: { label: "Tier 1 · Verifizierte Institution", color: "success" },
  tier_2_verified_small_business: { label: "Tier 2 · Verifizierter kleiner Betrieb", color: "success" },
  tier_3_verified_service_provider: { label: "Tier 3 · Verifizierter Dienstleister", color: "info" },
  tier_4_unverified: { label: "Tier 4 · Unverifiziert", color: "warning" },
  tier_5_restricted: { label: "Tier 5 · Restricted", color: "danger" },
};

const RISK_LEVEL_META = {
  low: { label: "Niedrig", color: "success" },
  medium: { label: "Mittel", color: "warning" },
  high: { label: "Hoch", color: "danger" },
  critical: { label: "Kritisch", color: "danger" },
};

const PUBLISHING_STAGE_META = {
  stage_a: { label: "Stufe A · nur Draft", color: "secondary" },
  stage_b: { label: "Stufe B · Review vor Sichtbarkeit", color: "warning" },
  stage_c: { label: "Stufe C · normales Publishing", color: "info" },
  stage_d: { label: "Stufe D · High Trust", color: "success" },
};

const TRUST_STATUS_META = {
  pending_identity_check: { label: "Identitaetspruefung offen", color: "warning" },
  pending_facility_check: { label: "Einrichtungspruefung offen", color: "warning" },
  pending_publishing_authority: { label: "Veroeffentlichungsbefugnis offen", color: "warning" },
  pending_first_ad_review: { label: "Erste Anzeige im Trust-Review", color: "info" },
  verified_direct_employer: { label: "Verifizierter Direktarbeitgeber", color: "success" },
  verified_service_provider: { label: "Verifizierter Service Provider", color: "info" },
  restricted: { label: "Eingeschraenkt", color: "danger" },
  rejected: { label: "Abgelehnt", color: "danger" },
};

const REVIEW_WORKFLOW_STATUS_META = {
  review_not_started: { label: "Review nicht gestartet", color: "secondary" },
  review_in_progress: { label: "Review in Pruefung", color: "info" },
  review_waiting_for_employer: { label: "Wartet auf Employer", color: "warning" },
  review_waiting_for_evidence: { label: "Wartet auf Nachweise", color: "warning" },
  review_completed_verified: { label: "Review verifiziert", color: "success" },
  review_completed_rejected: { label: "Review abgelehnt", color: "danger" },
};

const TRUST_TASK_STATUS_META = {
  open: { label: "Offen", color: "secondary" },
  in_progress: { label: "In Pruefung", color: "info" },
  completed: { label: "Erledigt", color: "success" },
  rejected: { label: "Abgelehnt", color: "danger" },
  requires_followup: { label: "Follow-up noetig", color: "warning" },
};

const TRUST_INCIDENT_STATUS_META = {
  open: { label: "Offen", color: "secondary" },
  under_review: { label: "Unter Pruefung", color: "warning" },
  confirmed: { label: "Bestaetigt", color: "danger" },
  rejected: { label: "Verworfen", color: "secondary" },
  resolved: { label: "Geloest", color: "success" },
};

const TRUST_INCIDENT_TYPE_LABELS = {
  fake_job: "Fake Job",
  hidden_intermediary: "Verdeckter Vermittler",
  wrong_employer_claim: "Falscher Arbeitgeber-Claim",
  payment_requested: "Provision / Zahlung verlangt",
  false_promise_housing: "Falsches Unterkunftsversprechen",
  interview_mismatch: "Interview-Mismatch",
  other: "Sonstiger Incident",
};

const TRUST_REVIEW_AREA_LABELS = {
  legal_entity: "Rechtstraeger",
  facility: "Einrichtung",
  domain_identity: "Domain & Identitaet",
  contact_person: "Ansprechpartner",
  publishing_authority: "Veroeffentlichungsbefugnis",
};

const SERVICE_PROVIDER_TYPES = new Set([
  "staffing_agency",
  "recruiter_intermediary",
  "consultant_third_party",
]);

const DIRECT_EMPLOYER_TYPES = new Set(["direct_employer"]);

const FREE_MAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "icloud.com",
  "aol.com",
  "gmx.de",
  "gmx.net",
  "web.de",
  "yahoo.com",
  "mail.com",
  "protonmail.com",
]);

const POSITIVE_ROLE_TOKENS = [
  "hr",
  "human resources",
  "talent",
  "recruiting",
  "recruitment",
  "personal",
  "einrichtungsleitung",
  "pflegedienstleitung",
  "geschaeftsfuehrung",
  "management",
  "leitung",
  "director",
  "direktor",
  "administrator",
  "owner",
];

const SUSPICIOUS_ROLE_TOKENS = [
  "agentur",
  "agency",
  "consultant",
  "berater",
  "vermittler",
  "headhunter",
  "freelance",
  "freelancer",
  "sourcing",
  "vendor",
  "outsourcing",
];

const SERVICE_PROVIDER_TOKENS = [
  "agency",
  "agentur",
  "consult",
  "recruit",
  "headhunt",
  "vermittlung",
  "staffing",
  "outsourcing",
];

const HOSPITAL_TOKENS = [
  "klinik",
  "klinikum",
  "hospital",
  "care",
  "pflege",
  "senior",
  "gesundheit",
  "nursing",
  "rehab",
];

const FLAG_LABELS = {
  free_mail_domain: "Freemail-Domain",
  domain_mismatch: "Domain-Mismatch",
  facility_name_mismatch: "Einrichtungsname unplausibel",
  missing_public_presence: "Keine oeffentliche Praesenz",
  suspicious_contact_role: "Kontaktrolle auffaellig",
  publishing_authority_missing: "Veroeffentlichungsbefugnis fehlt",
  suspected_intermediary: "Vermutete Vermittlerrolle",
  suspected_fake_employer: "Arbeitgeber nicht belastbar verifizierbar",
  employer_claim_conflict: "Arbeitgeber-Claim kollidiert mit Signalen",
  unverifiable_contact: "Kontakt nicht belastbar verifizierbar",
  applicant_complaint_flag: "Bewerberbeschwerde aktiv",
  trust_recheck_required: "Trust-Recheck erforderlich",
  publishing_hold: "Publishing-Hold aktiv",
  misrepresentation_flag: "Misrepresentation-Flag",
  trust_review_failed: "Trust-Review fehlgeschlagen",
  facility_mismatch: "Einrichtungs-Mismatch",
  review_tasks_blocking: "Blockierende Review-Tasks",
  active_trust_incident: "Aktive Trust-Incidents",
  critical_trust_incident: "Kritischer Trust-Incident",
  under_investigation: "Under Investigation",
  service_provider_representation_missing: "Vertretene Einrichtung fehlt",
  service_provider_mandate_missing: "Mandatsnachweis fehlt",
  suspicious_activity_flag: "Auffaelliges Verhalten",
  reality_check_requires_review: "Reality Check verlangt Review",
  gpt_high_risk_reality_check: "GPT-Reality-Check sieht hohes Risiko",
  gpt_company_existence_unclear: "GPT: Firma oeffentlich unklar",
  gpt_domain_brand_mismatch: "GPT: Domain / Marke unplausibel",
  gpt_job_company_mismatch: "GPT: Job passt nicht zur Firma",
  gpt_intermediary_language: "GPT: Vermittlersprache erkannt",
  gpt_hidden_intermediary_signal: "GPT: verdeckte Vermittlerrolle moeglich",
  gpt_fake_employer_signal: "GPT: Fake-Employer-Signal",
  gpt_location_mismatch: "GPT: Standort unplausibel",
  gpt_public_presence_gap: "GPT: oeffentliche Praesenz zu schwach",
  gpt_contact_plausibility_gap: "GPT: Kontaktrolle unplausibel",
  gpt_missing_external_evidence: "GPT: kaum externe Evidenz",
};

function compactText(value) {
  return String(value || "").trim();
}

function includesAnyToken(value, needles = []) {
  const normalized = String(value || "").toLowerCase();
  return needles.some((needle) => normalized.includes(String(needle).toLowerCase()));
}

function tokenList(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .split(" ")
    .map((entry) => entry.trim())
    .filter(Boolean);
}

function hasOverlap(left, right) {
  const leftTokens = new Set(tokenList(left));
  return tokenList(right).some((entry) => leftTokens.has(entry));
}

function extractDomain(value) {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";

  if (raw.includes("@")) {
    return raw.split("@").pop().replace(/^www\./, "").trim();
  }

  const withProtocol = /^https?:\/\//.test(raw) ? raw : `https://${raw}`;
  try {
    return new URL(withProtocol).hostname.toLowerCase().replace(/^www\./, "").trim();
  } catch (_error) {
    return raw
      .replace(/^https?:\/\//, "")
      .replace(/^www\./, "")
      .split("/")[0]
      .split(":")[0]
      .trim();
  }
}

function unique(values) {
  return Array.from(new Set((values || []).filter(Boolean)));
}

function parseFlags(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (!value) return [];
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return parseFlags(parsed);
    } catch (_error) {
      return value.split(",").map((entry) => String(entry || "").trim()).filter(Boolean);
    }
  }
  return [];
}

function resolveStatusLabel(status) {
  return TRUST_STATUS_META[status]?.label || "Unklar";
}

function normalizeServerTrustSummary(summary = {}) {
  return {
    ...summary,
    trustStatus: summary.trustStatus || summary.trust_status || "restricted",
    trustStatusLabel: summary.trustStatusLabel || resolveStatusLabel(summary.trustStatus || summary.trust_status),
    trustStatusColor: summary.trustStatusColor || getEmployerTrustStatusColor(summary.trustStatus || summary.trust_status),
    employerType: summary.employerType || summary.employer_type || "unknown_unverified",
    employerTypeLabel: summary.employerTypeLabel || formatEmployerTypeLabel(summary.employerType || summary.employer_type),
    employerClassification: summary.employerClassification || summary.employer_classification || "unknown",
    employerClassificationLabel: summary.employerClassificationLabel || EMPLOYER_CLASSIFICATION_LABELS[summary.employerClassification || summary.employer_classification || "unknown"] || "Unklar",
    trustTier: summary.trustTier || summary.trust_tier || "tier_4_unverified",
    trustTierLabel: summary.trustTierLabel || TRUST_TIER_META[summary.trustTier || summary.trust_tier || "tier_4_unverified"]?.label || "Tier unklar",
    publishingRightsStage: summary.publishingRightsStage || summary.publishing_rights_stage || "stage_a",
    publishingRightsStageLabel: summary.publishingRightsStageLabel || PUBLISHING_STAGE_META[summary.publishingRightsStage || summary.publishing_rights_stage || "stage_a"]?.label || "Stufe unklar",
    riskLevel: summary.riskLevel || summary.risk_level || "medium",
    riskLevelLabel: summary.riskLevelLabel || RISK_LEVEL_META[summary.riskLevel || summary.risk_level || "medium"]?.label || "Unklar",
    riskScore: Number(summary.riskScore || summary.risk_score || 0),
    flags: Array.isArray(summary.flags) ? summary.flags : [],
    publishBlockers: Array.isArray(summary.publishBlockers) ? summary.publishBlockers : [],
    missingVerifications: Array.isArray(summary.missingVerifications) ? summary.missingVerifications : [],
    counts: summary.counts || { verified: 0, unclear: 0, blocked: 0 },
    trustLevel: Number(summary.trustLevel || summary.trust_level || 0),
    complaintCount: Number(summary.complaintCount || summary.complaint_count || 0),
    activeComplaintFlag: Boolean(summary.activeComplaintFlag || summary.active_complaint_flag),
    trustRecheckRequired: Boolean(summary.trustRecheckRequired || summary.trust_recheck_required),
    publishingHold: Boolean(summary.publishingHold || summary.publishing_hold),
    misrepresentationFlag: Boolean(summary.misrepresentationFlag || summary.misrepresentation_flag),
    reviewWorkflowStatus: summary.reviewWorkflowStatus || summary.review_workflow_status || "review_not_started",
    trustLastVerifiedAt: summary.trustLastVerifiedAt || summary.trust_last_verified_at || null,
    trustRecheckDueAt: summary.trustRecheckDueAt || summary.trust_recheck_due_at || null,
    blockingTaskCount: Number(summary.blockingTaskCount || summary.trust_blocking_task_count || 0),
    activeIncidentCount: Number(summary.activeIncidentCount || summary.trust_active_incident_count || 0),
    criticalIncidentCount: Number(summary.criticalIncidentCount || summary.trust_critical_incident_count || 0),
    underInvestigation: Boolean(summary.underInvestigation || summary.trust_under_investigation),
    behaviorRiskScore: Number(summary.behaviorRiskScore || summary.behavior_risk_score || 0),
    suspiciousActivityFlag: Boolean(summary.suspiciousActivityFlag || summary.suspicious_activity_flag),
    evidencePack: summary.evidencePack || summary.evidence_pack || { items: [], missingRequiredLabels: [] },
    realityCheck: summary.realityCheck || summary.reality_check || {
      plausibilityScore: 0,
      riskScore: 0,
      flags: [],
      summary: "",
      recommendation: "",
      lastCheckedAt: null,
      requiresReview: false,
    },
    canPublishLive: Boolean(summary.canPublishLive),
  };
}

export function getEmployerTrustStatusColor(status) {
  return TRUST_STATUS_META[status]?.color || "secondary";
}

export function formatEmployerTrustStatusLabel(status) {
  return resolveStatusLabel(status);
}

export function formatEmployerTypeLabel(type) {
  return EMPLOYER_TYPE_LABELS[type] || "Unklar";
}

export function formatEmployerClassificationLabel(classification) {
  return EMPLOYER_CLASSIFICATION_LABELS[classification] || "Unklar";
}

export function formatTrustTierLabel(tier) {
  return TRUST_TIER_META[tier]?.label || "Tier unklar";
}

export function getTrustTierColor(tier) {
  return TRUST_TIER_META[tier]?.color || "secondary";
}

export function formatRiskLevelLabel(level) {
  return RISK_LEVEL_META[level]?.label || "Unklar";
}

export function getRiskLevelColor(level) {
  return RISK_LEVEL_META[level]?.color || "secondary";
}

export function formatPublishingRightsStageLabel(stage) {
  return PUBLISHING_STAGE_META[stage]?.label || "Stufe unklar";
}

export function getPublishingRightsStageColor(stage) {
  return PUBLISHING_STAGE_META[stage]?.color || "secondary";
}

export function formatEmployerTrustFlagLabel(flag) {
  return FLAG_LABELS[flag] || flag || "Signal";
}

export function buildEmployerTrustSummary(profile = {}) {
  if (profile?.trust_summary) {
    return normalizeServerTrustSummary(profile.trust_summary);
  }

  const employerType = String(profile.employer_type || "unknown_unverified").trim().toLowerCase() || "unknown_unverified";
  const websiteDomain = extractDomain(profile.official_website);
  const emailDomain = extractDomain(profile.official_domain_email);
  const freeMailDomain = Boolean(emailDomain && FREE_MAIL_DOMAINS.has(emailDomain));
  const officialDomainMatch = Boolean(
    websiteDomain
    && emailDomain
    && (emailDomain === websiteDomain
      || emailDomain.endsWith(`.${websiteDomain}`)
      || websiteDomain.endsWith(`.${emailDomain}`))
  );
  const publicWebsiteMatch = Boolean(websiteDomain);
  const emailDomainMatch = Boolean(emailDomain && !freeMailDomain && officialDomainMatch);
  const phoneMatch = Boolean(compactText(profile.official_phone));
  const contactRolePlausible = includesAnyToken(profile.contact_person_role, POSITIVE_ROLE_TOKENS)
    && !includesAnyToken(profile.contact_person_role, SUSPICIOUS_ROLE_TOKENS);
  const legalEntityMatch = Boolean(compactText(profile.legal_entity_name) && compactText(profile.legal_entity_proof));
  const facilityReferencePresent = Boolean(compactText(profile.facility_name) && compactText(profile.facility_proof));
  const facilityMatch = Boolean(
    facilityReferencePresent
    && (
      hasOverlap(profile.facility_name, profile.official_website)
      || hasOverlap(profile.facility_name, profile.legal_entity_name)
      || hasOverlap(profile.facility_name, profile.facility_proof)
    )
  );
  const serviceProviderClaim = SERVICE_PROVIDER_TYPES.has(employerType)
    || includesAnyToken(profile.contact_person_role, SUSPICIOUS_ROLE_TOKENS)
    || includesAnyToken(profile.official_website, SERVICE_PROVIDER_TOKENS)
    || includesAnyToken(profile.legal_entity_name, SERVICE_PROVIDER_TOKENS);
  const suspiciousContactRole = Boolean(compactText(profile.contact_person_role)) && !contactRolePlausible;
  const publishingAuthorityMissing = !(
    compactText(profile.contact_person_name)
    && compactText(profile.contact_person_role)
    && compactText(profile.publishing_authority_proof)
  );
  const employerClaimConflict = DIRECT_EMPLOYER_TYPES.has(employerType) && serviceProviderClaim;
  const missingPublicPresence = !publicWebsiteMatch;
  const domainMismatch = Boolean(emailDomain && websiteDomain) && !officialDomainMatch;
  const facilityNameMismatch = Boolean(compactText(profile.facility_name)) && !facilityMatch;
  const complaintCount = Math.max(0, Number(profile.complaint_count || 0));
  const activeComplaintFlag = Boolean(profile.active_complaint_flag);
  const trustRecheckRequired = Boolean(profile.trust_recheck_required);
  const publishingHold = Boolean(profile.publishing_hold);
  const misrepresentationFlag = Boolean(profile.misrepresentation_flag);
  const firstAdReviewStatus = String(profile.first_ad_review_status || "pending").trim().toLowerCase() || "pending";
  const domainVerificationStatus = String(
    profile.domain_verification_status
    || (freeMailDomain
      ? "free_mail"
      : !compactText(profile.official_domain_email) || !compactText(profile.official_website)
        ? "missing"
        : officialDomainMatch
          ? "verified"
          : "mismatch")
  ).trim().toLowerCase();
  const legalEntityVerificationStatus = String(
    profile.legal_entity_verification_status
    || (!compactText(profile.legal_entity_name) ? "missing" : legalEntityMatch ? "verified" : "pending")
  ).trim().toLowerCase();
  const facilityVerificationStatus = String(
    profile.facility_verification_status
    || (!compactText(profile.facility_name) ? "missing" : facilityMatch ? "verified" : "pending")
  ).trim().toLowerCase();
  const publishingAuthorityStatus = String(
    profile.publishing_authority_status
    || (publishingAuthorityMissing ? "missing" : "pending")
  ).trim().toLowerCase();

  const flags = unique([
    ...parseFlags(profile.trust_flags_json),
    freeMailDomain ? "free_mail_domain" : "",
    domainMismatch ? "domain_mismatch" : "",
    facilityNameMismatch ? "facility_name_mismatch" : "",
    missingPublicPresence ? "missing_public_presence" : "",
    suspiciousContactRole ? "suspicious_contact_role" : "",
    publishingAuthorityMissing ? "publishing_authority_missing" : "",
    serviceProviderClaim || employerClaimConflict ? "suspected_intermediary" : "",
    !legalEntityMatch && !facilityReferencePresent && !publicWebsiteMatch ? "suspected_fake_employer" : "",
    employerClaimConflict ? "employer_claim_conflict" : "",
    !(phoneMatch && compactText(profile.contact_person_name) && compactText(profile.official_domain_email)) ? "unverifiable_contact" : "",
    complaintCount > 0 || activeComplaintFlag ? "applicant_complaint_flag" : "",
    trustRecheckRequired ? "trust_recheck_required" : "",
    publishingHold ? "publishing_hold" : "",
    misrepresentationFlag ? "misrepresentation_flag" : "",
    firstAdReviewStatus === "failed" ? "trust_review_failed" : "",
    compactText(profile.facility_type) && compactText(profile.facility_type) !== "other" && !facilityMatch ? "facility_mismatch" : "",
  ]);

  let trustStatus = "restricted";
  if (employerType === "rejected_misrepresentation" || flags.includes("misrepresentation_flag") || flags.includes("trust_review_failed")) {
    trustStatus = "rejected";
  } else if (legalEntityVerificationStatus !== "verified") {
    trustStatus = "pending_identity_check";
  } else if (facilityVerificationStatus !== "verified") {
    trustStatus = "pending_facility_check";
  } else if (publishingAuthorityStatus !== "verified" || domainVerificationStatus !== "verified") {
    trustStatus = "pending_publishing_authority";
  } else if (firstAdReviewStatus !== "approved") {
    trustStatus = "pending_first_ad_review";
  } else if (flags.some((flag) => [
    "free_mail_domain",
    "domain_mismatch",
    "facility_name_mismatch",
    "facility_mismatch",
    "missing_public_presence",
    "suspicious_contact_role",
    "publishing_authority_missing",
    "suspected_fake_employer",
    "employer_claim_conflict",
    "applicant_complaint_flag",
    "trust_recheck_required",
    "publishing_hold",
    "misrepresentation_flag",
    "trust_review_failed",
  ].includes(flag))) {
    trustStatus = "restricted";
  } else if (DIRECT_EMPLOYER_TYPES.has(employerType)) {
    trustStatus = "verified_direct_employer";
  } else if (SERVICE_PROVIDER_TYPES.has(employerType)) {
    trustStatus = "verified_service_provider";
  }

  const publishBlockers = unique([
    trustStatus !== "verified_direct_employer" ? "Nur verifizierte Direktarbeitgeber duerfen derzeit live publizieren." : "",
    SERVICE_PROVIDER_TYPES.has(employerType) ? "Service Provider duerfen ohne transparente Drittanbieter-Darstellung nicht live publizieren." : "",
    firstAdReviewStatus !== "approved" ? "Die erste Anzeige hat den verpflichtenden Trust-Review noch nicht bestanden." : "",
    domainVerificationStatus === "free_mail" ? "Freemail-Domain reicht nie fuer einen verifizierten Direktarbeitgeber." : "",
    domainVerificationStatus === "mismatch" ? "E-Mail-Domain und offizielle Website passen nicht zusammen." : "",
    publishingAuthorityStatus !== "verified" ? "Die Veroeffentlichungsbefugnis ist nicht verifiziert." : "",
    legalEntityVerificationStatus !== "verified" ? "Der Rechtstraeger ist nicht verifiziert." : "",
    facilityVerificationStatus !== "verified" ? "Die Einrichtung ist nicht verifiziert." : "",
    flags.includes("employer_claim_conflict") ? "Der Arbeitgeber-Claim kollidiert mit Vermittler- oder Drittanbieter-Signalen." : "",
    flags.includes("suspected_fake_employer") ? "Die Einrichtung wirkt derzeit nicht belastbar verifizierbar." : "",
    publishingHold ? "Auf dem Employer liegt ein Publishing-Hold." : "",
    trustRecheckRequired ? "Trust-Recheck ist aktiv." : "",
    activeComplaintFlag ? "Aktive Bewerberbeschwerden blockieren die Live-Schaltung." : "",
    misrepresentationFlag ? "Misrepresentation-Flag blockiert die Live-Schaltung." : "",
  ]);

  const missingVerifications = unique([
    legalEntityVerificationStatus !== "verified" ? "Rechtstraeger nicht verifiziert" : "",
    facilityVerificationStatus !== "verified" ? "Einrichtung nicht verifiziert" : "",
    domainVerificationStatus !== "verified" ? "Domain- oder Kontaktpruefung offen" : "",
    publishingAuthorityStatus !== "verified" ? "Veroeffentlichungsbefugnis nicht bestaetigt" : "",
    firstAdReviewStatus !== "approved" ? "Erste Anzeige braucht Trust-Review" : "",
  ]);

  const nextTrustAction = trustStatus === "pending_identity_check"
    ? "Rechtstraeger und Nachweis sauber verifizieren."
    : trustStatus === "pending_facility_check"
      ? "Einrichtungsreferenz und oeffentliche Zuordnung absichern."
      : trustStatus === "pending_publishing_authority"
        ? "offizielle Kontaktidentitaet und Veroeffentlichungsbefugnis bestaetigen."
        : trustStatus === "pending_first_ad_review"
          ? "erste Anzeige manuell trust-pruefen, bevor live geschaltet wird."
          : trustStatus === "verified_service_provider"
            ? "nur mit transparenter Service-Provider-Kennzeichnung weiterarbeiten."
            : trustStatus === "verified_direct_employer"
              ? "Trust halten und Beschwerde-/Mismatch-Signale weiter beobachten."
              : trustStatus === "rejected"
                ? "Employer als Live-Quelle gesperrt halten und Misrepresentation nachhalten."
                : "Trust-Blocker pruefen und Publishing-Hold klaeren.";

  const employerClassification = String(profile.employer_classification || (
    serviceProviderClaim
      ? employerType === "staffing_agency"
        ? "staffing_agency"
        : "recruiter_intermediary"
      : includesAnyToken([profile.facility_name, profile.legal_entity_name, profile.official_website].join(" "), HOSPITAL_TOKENS)
        ? "hospital_or_care"
        : publicWebsiteMatch
          ? "small_business"
          : "unknown"
  )).trim().toLowerCase() || "unknown";
  const trustTier = String(profile.trust_tier || (
    trustStatus === "verified_direct_employer"
      ? ["enterprise", "public_institution", "hospital_or_care"].includes(employerClassification)
        ? "tier_1_verified_institutional"
        : "tier_2_verified_small_business"
      : trustStatus === "verified_service_provider"
        ? "tier_3_verified_service_provider"
        : ["restricted", "rejected"].includes(trustStatus)
          ? "tier_5_restricted"
          : "tier_4_unverified"
  )).trim().toLowerCase() || "tier_4_unverified";
  const publishingRightsStage = String(profile.publishing_rights_stage || (
    trustStatus === "verified_direct_employer" && publishBlockers.length === 0
      ? "stage_c"
      : ["restricted", "rejected"].includes(trustStatus)
        ? "stage_a"
        : "stage_b"
  )).trim().toLowerCase() || "stage_a";
  const riskScore = Number(profile.risk_score || profile.reality_check_risk_score || 0);
  const riskLevel = String(profile.risk_level || (
    riskScore >= 0.8
      ? "critical"
      : riskScore >= 0.6 || flags.includes("suspected_fake_employer")
        ? "high"
        : riskScore >= 0.3 || flags.length
          ? "medium"
          : "low"
  )).trim().toLowerCase() || "medium";
  const behaviorRiskScore = Number(profile.behavior_risk_score || 0);
  const realityCheck = {
    plausibilityScore: Number(profile.reality_check_plausibility_score || 0),
    riskScore: Number(profile.reality_check_risk_score || 0),
    flags: parseFlags(profile.reality_check_flags_json),
    summary: compactText(profile.reality_check_summary) || "",
    recommendation: compactText(profile.reality_check_recommendation) || "",
    lastCheckedAt: profile.reality_check_last_checked_at || null,
    requiresReview: Boolean(profile.reality_check_requires_review),
  };
  const evidencePack = {
    items: [],
    missingRequiredLabels: missingVerifications,
  };

  return {
    employerType,
    employerTypeLabel: formatEmployerTypeLabel(employerType),
    employerClassification,
    employerClassificationLabel: formatEmployerClassificationLabel(employerClassification),
    trustStatus,
    trustStatusLabel: resolveStatusLabel(trustStatus),
    trustStatusColor: getEmployerTrustStatusColor(trustStatus),
    trustTier,
    trustTierLabel: formatTrustTierLabel(trustTier),
    publishingRightsStage,
    publishingRightsStageLabel: formatPublishingRightsStageLabel(publishingRightsStage),
    riskLevel,
    riskLevelLabel: formatRiskLevelLabel(riskLevel),
    riskScore,
    trustLevel: trustStatus === "verified_direct_employer" ? 4 : trustStatus === "verified_service_provider" ? 3 : trustStatus.startsWith("pending_") ? 2 : trustStatus === "restricted" ? 1 : 0,
    signals: {
      official_domain_match: officialDomainMatch,
      public_website_match: publicWebsiteMatch,
      email_domain_match: emailDomainMatch,
      phone_match: phoneMatch,
      contact_role_plausible: contactRolePlausible,
      legal_entity_match: legalEntityMatch,
      facility_match: facilityMatch,
    },
    domainVerificationStatus,
    legalEntityVerificationStatus,
    facilityVerificationStatus,
    publishingAuthorityStatus,
    firstAdReviewStatus,
    flags,
    missingVerifications,
    nextTrustAction,
    publishBlockers,
    canPublishLive: publishBlockers.length === 0 && trustStatus === "verified_direct_employer",
    complaintCount,
    activeComplaintFlag,
    trustRecheckRequired,
    publishingHold,
    misrepresentationFlag,
    reviewWorkflowStatus: String(profile.trust_review_status || "review_not_started").trim().toLowerCase() || "review_not_started",
    trustLastVerifiedAt: profile.trust_last_verified_at || null,
    trustRecheckDueAt: profile.trust_recheck_due_at || null,
    blockingTaskCount: Number(profile.trust_blocking_task_count || 0),
    activeIncidentCount: Number(profile.trust_active_incident_count || 0),
    criticalIncidentCount: Number(profile.trust_critical_incident_count || 0),
    underInvestigation: Boolean(profile.trust_under_investigation),
    behaviorRiskScore,
    suspiciousActivityFlag: Boolean(profile.suspicious_activity_flag),
    evidencePack,
    realityCheck,
    counts: {
      verified: trustStatus === "verified_direct_employer" || trustStatus === "verified_service_provider" ? 1 : 0,
      unclear: trustStatus.startsWith("pending_") ? 1 : 0,
      blocked: ["restricted", "rejected"].includes(trustStatus) ? 1 : 0,
    },
  };
}

export function formatTrustReviewWorkflowStatusLabel(status) {
  return REVIEW_WORKFLOW_STATUS_META[status]?.label || "Unklar";
}

export function getTrustReviewWorkflowStatusColor(status) {
  return REVIEW_WORKFLOW_STATUS_META[status]?.color || "secondary";
}

export function formatTrustTaskStatusLabel(status) {
  return TRUST_TASK_STATUS_META[status]?.label || "Unklar";
}

export function getTrustTaskStatusColor(status) {
  return TRUST_TASK_STATUS_META[status]?.color || "secondary";
}

export function formatTrustIncidentStatusLabel(status) {
  return TRUST_INCIDENT_STATUS_META[status]?.label || "Unklar";
}

export function getTrustIncidentStatusColor(status) {
  return TRUST_INCIDENT_STATUS_META[status]?.color || "secondary";
}

export function formatTrustIncidentTypeLabel(type) {
  return TRUST_INCIDENT_TYPE_LABELS[type] || type || "Incident";
}

export function buildEmployerTrustOpsSummary(profile = {}) {
  const trustSummary = buildEmployerTrustSummary(profile);
  const trustOps = profile?.trust_ops || {};
  const counts = trustOps?.summary || {};
  return {
    trustTier: trustSummary.trustTier,
    trustTierLabel: trustSummary.trustTierLabel,
    trustTierColor: getTrustTierColor(trustSummary.trustTier),
    employerClassification: trustSummary.employerClassification,
    employerClassificationLabel: trustSummary.employerClassificationLabel,
    riskLevel: trustSummary.riskLevel,
    riskLevelLabel: trustSummary.riskLevelLabel,
    riskLevelColor: getRiskLevelColor(trustSummary.riskLevel),
    publishingRightsStage: trustSummary.publishingRightsStage,
    publishingRightsStageLabel: trustSummary.publishingRightsStageLabel,
    publishingRightsStageColor: getPublishingRightsStageColor(trustSummary.publishingRightsStage),
    reviewWorkflowStatus: trustSummary.reviewWorkflowStatus,
    reviewWorkflowLabel: formatTrustReviewWorkflowStatusLabel(trustSummary.reviewWorkflowStatus),
    reviewWorkflowColor: getTrustReviewWorkflowStatusColor(trustSummary.reviewWorkflowStatus),
    openTasks: Number(counts.openTasks || 0),
    blockingTasks: Number(counts.blockingTasks || trustSummary.blockingTaskCount || 0),
    completedTasks: Number(counts.completedTasks || 0),
    activeIncidents: Number(counts.activeIncidents || trustSummary.activeIncidentCount || 0),
    criticalIncidents: Number(counts.criticalIncidents || trustSummary.criticalIncidentCount || 0),
    underInvestigation: Boolean(counts.underInvestigation || trustSummary.underInvestigation),
    nextAction: counts.nextAction || trustSummary.nextTrustAction,
    blockers: Array.isArray(counts.blockers) ? counts.blockers : [],
    behaviorRiskScore: Number(counts.behaviorRiskScore || trustSummary.behaviorRiskScore || 0),
    suspiciousActivityFlag: Boolean(counts.suspiciousActivityFlag || trustSummary.suspiciousActivityFlag),
    realityCheck: trustSummary.realityCheck || {
      plausibilityScore: 0,
      riskScore: 0,
      flags: [],
      summary: "",
      recommendation: "",
      lastCheckedAt: null,
      requiresReview: false,
    },
  };
}

export function buildEmployerTrustReviewRows(profile = {}) {
  return (profile?.trust_ops?.areas || []).map((entry) => ({
    id: entry.id,
    areaKey: entry.area_key,
    areaLabel: TRUST_REVIEW_AREA_LABELS[entry.area_key] || entry.area_key,
    reviewStatus: entry.review_status,
    reviewStatusLabel: formatTrustReviewWorkflowStatusLabel(entry.review_status),
    reviewStatusColor: getTrustReviewWorkflowStatusColor(entry.review_status),
    reviewNotes: entry.review_notes || "",
    reviewedAt: entry.reviewed_at || null,
    reviewedBy: entry.reviewed_by || "-",
  }));
}

export function buildEmployerTrustTaskRows(profile = {}) {
  return (profile?.trust_ops?.tasks || []).map((entry) => ({
    id: entry.id,
    title: entry.title,
    areaKey: entry.area_key,
    status: entry.status,
    statusLabel: formatTrustTaskStatusLabel(entry.status),
    statusColor: getTrustTaskStatusColor(entry.status),
    blocking: entry.is_blocking ? "ja" : "nein",
    nextAction: entry.next_action || "-",
    notes: entry.task_notes || "",
    dueAt: entry.due_at || null,
    reviewedAt: entry.reviewed_at || null,
    reviewedBy: entry.reviewed_by || "-",
    raw: entry,
  }));
}

export function buildEmployerTrustIncidentRows(profile = {}) {
  return (profile?.trust_ops?.incidents || []).map((entry) => ({
    id: entry.id,
    type: entry.incident_type,
    typeLabel: formatTrustIncidentTypeLabel(entry.incident_type),
    severity: entry.severity,
    status: entry.status,
    statusLabel: formatTrustIncidentStatusLabel(entry.status),
    statusColor: getTrustIncidentStatusColor(entry.status),
    reportedBy: entry.reported_by || "-",
    reportedAt: entry.reported_at || null,
    summary: entry.summary || "",
    actionTaken: entry.action_taken || "",
    raw: entry,
  }));
}

export function buildEmployerTrustHistoryRows(profile = {}) {
  return (profile?.trust_ops?.history || []).map((entry) => ({
    id: entry.id,
    eventType: entry.event_type,
    reason: entry.reason || "",
    changedBy: entry.changed_by || "-",
    changedAt: entry.changed_at || null,
  }));
}

export function buildEmployerTrustEvidenceRows(profile = {}) {
  const trustSummary = buildEmployerTrustSummary(profile);
  return (trustSummary.evidencePack?.items || []).map((entry) => ({
    id: entry.key,
    label: entry.label,
    required: entry.required ? "Pflicht" : "Optional",
    status: entry.ready ? "erfuellt" : "offen",
    statusColor: entry.ready ? "success" : entry.required ? "warning" : "secondary",
    note: entry.note || "",
  }));
}

export function buildEmployerTrustBlockerRows(profile = {}) {
  const trustSummary = buildEmployerTrustSummary(profile);
  return trustSummary.publishBlockers.map((entry, index) => ({
    id: `trust-blocker-${index}`,
    blocker: entry,
    status: trustSummary.trustStatusLabel,
    priority: ["rejected", "restricted"].includes(trustSummary.trustStatus) ? "hoch" : "mittel",
    nextAction: trustSummary.nextTrustAction,
  }));
}

export function buildEmployerTrustSignalRows(profile = {}) {
  const trustSummary = buildEmployerTrustSummary(profile);
  return [
    { id: "official_domain_match", label: "Official Domain Match", ok: trustSummary.signals.official_domain_match },
    { id: "public_website_match", label: "Public Website Match", ok: trustSummary.signals.public_website_match },
    { id: "email_domain_match", label: "Email Domain Match", ok: trustSummary.signals.email_domain_match },
    { id: "phone_match", label: "Phone Match", ok: trustSummary.signals.phone_match },
    { id: "contact_role_plausible", label: "Contact Role Plausible", ok: trustSummary.signals.contact_role_plausible },
    { id: "legal_entity_match", label: "Legal Entity Match", ok: trustSummary.signals.legal_entity_match },
    { id: "facility_match", label: "Facility Match", ok: trustSummary.signals.facility_match },
  ];
}
